/** ISO 4217 currency code used by default across the app. */
export const DEFAULT_CURRENCY_CODE = "USD";

/** `display` argument for Angular `CurrencyPipe` (e.g., shows "$" instead of "USD"). */
export const CURRENCY_DISPLAY = "symbol";

/** `digitsInfo` argument for Angular `CurrencyPipe`: min 1 integer, 0–2 decimals. */
export const CURRENCY_DIGITS_INFO = "1.0-2";
